module.exports = __webpack_public_path__ + "img/alert.4ec8b903.png";